import * as React from "react";
const SvgFiRrFireFlameCurved = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-fire-flame-curved_svg__a)">
      <path
        fill="#062147"
        d="M18.044 5.529c-1.098-1.426-2.233-2.9-3.036-4.495-.339-.675-1.013-1.082-1.752-1.042-.713.041-1.314.496-1.569 1.188-.342.933-.687 2.638-.687 4.345 0 2.209.688 3.701 1.24 4.901.469 1.017.839 1.82.746 2.847-.09.979-.946 1.735-2.027 1.727-2.585-.029-3.243-3.303-3.338-6.043a2.01 2.01 0 0 0-1.505-1.885 2.02 2.02 0 0 0-2.241.896c-1.208 1.961-1.874 4.103-1.874 6.031 0 5.514 4.523 10 10.006 10 5.511-.033 9.994-4.52 9.994-9.983.056-3.276-1.984-5.925-3.957-8.487M11.994 22C7.614 22 4 18.411 4 14c0-1.54.575-3.356 1.622-4.973.179 5.104 2.066 7.936 5.315 7.973h.047c2.061 0 3.811-1.548 3.994-3.544.142-1.56-.398-2.732-.921-3.866C13.537 8.462 13 7.296 13 5.526c0-1.153.196-2.384.423-3.206.863 1.606 1.967 3.04 3.037 4.431 1.843 2.395 3.584 4.656 3.541 7.25 0 4.385-3.591 7.974-8.006 8z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-fire-flame-curved_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFireFlameCurved;
